import {useMemo} from 'react';
import {Button} from '~library/atoms/Button';
import {Typography} from '~library/atoms/Typography';
import {AreaIcon} from '~library/svg/AreaIcon';
import {DeleteBinLineIcon} from '~library/svg/DeleteBinLineIcon';
import {IntersectionIcon} from '~library/svg/IntersectionIcon';
import {TransferIcon} from '~library/svg/TransferIcon';
import './MainPhotoEditorMenu.sass';

export const MainPhotoEditorMenu = ({onMenuItemClick}) => {
  const menuItems = useMemo(
    () => [
      {
        id: 'transform',
        icon: <AreaIcon />,
        label: 'Transform',
      },
      {
        id: 'filters',
        icon: <IntersectionIcon />,
        label: 'Filters',
      },
      {
        id: 'swap',
        icon: <TransferIcon />,
        label: 'Swap photo',
      },
      {
        id: 'remove',
        icon: <DeleteBinLineIcon />,
        label: 'Remove',
      },
    ],
    []
  );

  return (
    <div className="main-photo-editor-menu">
      {menuItems.map((item) => (
        <Button
          variant="unstyled-button"
          key={item.id}
          className="main-photo-editor-menu__item"
          onClick={() => onMenuItemClick(item.id)}
          data-qa-id={`photo-editor-${item.id}-btn`}
        >
          <div className="main-photo-editor-menu__item-icon">{item.icon}</div>
          <Typography variant="paragraph3" className="main-photo-editor-menu__item-label">
            {item.label}
          </Typography>
        </Button>
      ))}
    </div>
  );
};
